export default __webpack_public_path__ + "static/about-f529fe26650da107dc0dcb6303d09a47.png";